import React from "react";

const Resumes = () => {
  return (
    <div>
      <h1>Gestión de Currículums</h1>
      <p>Administra los currículums cargados por los usuarios.</p>
    </div>
  );
};

export default Resumes;
